import type { routes } from '@semios/app-platform-banyan-route-definitions'
import { PersistentStoreName } from 'stores/_utils/persistentStore/persistenceStoresCleanUpMap'
import { persistentInit } from 'stores/_utils/persistentStore/persistentStore'
import type { ImperialXorMetric } from 'stores/fieldAssetStore/fieldAssetStore'

export type TFlowRateUnit = 'GPM' | 'CFS' | 'LS' | 'M3S' | 'M3H'

export type TVolumeUnit = 'GAL' | 'CF' | 'AF' | 'M3' | 'ML'

export const userDetailsStore = persistentInit<TUserDetailsStoreState>({
  initialState: {
    accountType: null,
    availableSemiosDefinedPresets: null,
    availableUserDefinedPresets: null,
    depth: 'METRIC',
    email: '',
    fertigation: 'METRIC',
    firstName: '',
    id: null,
    intercomToken: null,
    language: '',
    lastName: '',
    permissions: {},
    rain: 'METRIC',
    smsNumber: null,
    speed: 'METRIC',
    temperature: 'METRIC',
    pressure: 'METRIC',
    flowRate: 'GPM',
    volume: 'GAL',
    hasAgreedToCurrentAcceptancePackage: false,
    isFreeRegionalUser: false,
    location: undefined,
  },
  keysToPutInPersistentStorage: {
    accountType: true,
    availableSemiosDefinedPresets: true,
    availableUserDefinedPresets: true,
    depth: true,
    email: true,
    fertigation: true,
    firstName: true,
    id: true,
    intercomToken: true,
    language: true,
    lastName: true,
    permissions: true,
    rain: true,
    smsNumber: true,
    speed: true,
    temperature: true,
    pressure: true,
    flowRate: true,
    volume: true,
    hasAgreedToCurrentAcceptancePackage: true,
    isFreeRegionalUser: false,
    location: false,
  },
  keysToPutInURL: {
    accountType: false,
    availableSemiosDefinedPresets: false,
    availableUserDefinedPresets: false,
    depth: false,
    email: false,
    fertigation: false,
    firstName: false,
    id: false,
    intercomToken: false,
    language: false,
    lastName: false,
    permissions: false,
    rain: false,
    smsNumber: false,
    speed: false,
    temperature: false,
    pressure: false,
    flowRate: false,
    volume: false,
    hasAgreedToCurrentAcceptancePackage: false,
    isFreeRegionalUser: false,
    location: false,
  },
  storeName: PersistentStoreName.USER_DETAILS_STORE,
})

export type TUserDetailsStoreState = {
  id: number | null
  firstName: string
  lastName: string
  email: string
  smsNumber: string | null
  speed: ImperialXorMetric
  temperature: ImperialXorMetric
  depth: ImperialXorMetric
  fertigation: ImperialXorMetric
  rain: ImperialXorMetric
  pressure: ImperialXorMetric
  flowRate: TFlowRateUnit
  volume: TVolumeUnit
  language: routes.UserAppStartup.Response['user']['language'] | ''
  accountType: routes.UserAppStartup.Response['user']['accountType'] | null
  permissions: routes.UserAppStartup.Response['user']['permissions']
  availableSemiosDefinedPresets: routes.UserAppStartup.Response['user']['availableSemiosDefinedPresets']
  availableUserDefinedPresets: routes.UserAppStartup.Response['user']['availableUserDefinedPresets']
  intercomToken: routes.UserAppStartup.Response['user']['intercomToken']
  hasAgreedToCurrentAcceptancePackage: boolean
  isFreeRegionalUser: boolean
  location: routes.UserAppStartup.Response['user']['location']
}
